import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { deleteCookie, getCookie, setCookie } from '../../../utilities/cookies';
import { HelpService } from '../../../services/help.service';
import { IdleService } from '../../../services/idle.service';
import { ExperienceManager } from '../../../managers/experience.manager';
import { map, Observable } from 'rxjs';
import { AppStore } from '@store/legacy/app.store';
import { BaseComponent } from '../../base.component';
import { Store } from '@ngrx/store';
import { UserConfigsActions } from "@store/app.actions";

@Component({
    selector: 'lex-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent extends BaseComponent implements OnInit, OnDestroy {
	public hasError: boolean = false;
	public loginForm = this.formBuilder.group({
		username: [null, Validators.required],
		password: [null, Validators.required],
		rememberUsername: [false, null]
	});

	public loginPosterUrl$: Observable<string> = this.appStore.appState$.pipe(
		map((x) => x?.loginPosterUrl)
	);

	public isLoading: boolean = false;
	constructor(
		private readonly router: Router,
		private readonly formBuilder: UntypedFormBuilder,
		private readonly authenticationService: AuthenticationService,
		private readonly helpService: HelpService,
		private readonly idleService: IdleService,
		private readonly experienceManager: ExperienceManager,
		private readonly activatedRoute: ActivatedRoute,
		private appStore: AppStore,
		private store: Store
	) {
		super();

		this.experienceManager.updateState({
			showTopBar: false
		});
	}

	ngOnDestroy() {
		this.experienceManager.updateState({
			showTopBar: true
		});
	}

	ngOnInit() {
		const userName = getCookie('UserName');
		if (userName != undefined) {
			this.loginForm = this.formBuilder.group({
				username: [userName, Validators.required],
				password: [null, Validators.required],
				rememberUsername: [true, null]
			});
		}

		this.helpService.updateHelpLink('logging-in');
	}

	public onSubmit() {
		if (!this.loginForm.valid) return;

		this.isLoading = true;

		if (this.loginForm.value.rememberUsername) {
			setCookie('UserName', this.loginForm.value.username);
		} else {
			deleteCookie('UserName');
		}
		this.hasError = false;
		this.authenticationService
			.login(this.loginForm.value.username, this.loginForm.value.password)
			.subscribe({
				next: (x) => {
					const isMfaEnabled = x.rol === 'mfa';
					this.handleLogin(isMfaEnabled);
				},
				error: () => {
					this.isLoading = false;
					this.hasError = true;
				}
			});
	}

	public handleLogin(isMfaEnabled: boolean = false) {
		this.idleService.watch();
		if (isMfaEnabled) {
			this.router.navigate(['../mfa-selection'], { relativeTo: this.activatedRoute });
		} else {
			this.router.navigate(['/']);
			this.store.dispatch(UserConfigsActions.authenticated());
		}
	}
}
